import { fontSize, fontWeight } from '../font';

export const typographyFonts = {
  h1: {
    fontWeight: fontWeight.regular,
    fontSize: fontSize._56,
    lineHeight: 1.323,
  },
  h2: {
    fontWeight: fontWeight.regular,
    fontSize: fontSize._48,
    lineHeight: 1.323,
  },
  h3: {
    fontWeight: fontWeight.regular,
    fontSize: fontSize._32,
    lineHeight: 1.323,
  },
  h4: {
    fontWeight: fontWeight.regular,
    fontSize: fontSize._24,
    lineHeight: 1.323,
  },
  h5: {
    fontWeight: fontWeight.regular,
    fontSize: fontSize._20,
    lineHeight: 1.323,
  },
  h6: {
    fontWeight: fontWeight.regular,
    fontSize: fontSize._18,
    lineHeight: 1.323,
  },
  subtitle1: {
    // for future use
  },
  subtitle2: {
    // for future use
  },
  body1: {
    fontWeight: fontWeight.regular,
    fontSize: fontSize._16,
    lineHeight: 1.323,
  },
  body2: {
    fontWeight: fontWeight.regular,
    fontSize: fontSize._14,
    lineHeight: 1.323,
  },
  caption: {
    fontWeight: fontWeight.regular,
    fontSize: fontSize._12,
    lineHeight: 1.323,
  },
  overline: {
    // for future use
  },
  button: {
    // for future use
  },
};
